import "./About.css";


function About() {

  return (

<section className="about" id="about">

<div className="container">

<div className="row align-items-center">

<div className="col-lg-6">


<img
src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=900"
alt="About"
className="img-fluid about-img"
/>

</div>

<div className="col-lg-6">

<h5>ABOUT POTECH TECHNOLOGIES</h5>

<h2>

Innovative IT Solutions
For Modern Businesses

</h2>

<p>

Potech Technologies is a professional software and website
development company based in Nashik.

We provide modern websites,
custom software,
ERP systems,
business automation,
e-commerce solutions,
digital branding,
and technical consulting.

</p>

<ul>

<li>✔ Business Websites</li>

<li>✔ Custom Software</li>

<li>✔ ERP Development</li>

<li>✔ E-Commerce Website</li>

<li>✔ Website Maintenance</li>

<li>✔ Digital Solutions</li>

</ul>

<a href="#contact" className="btn btn-primary">

Know More

</a>

</div>

</div>

</div>

</section>

  );

}

export default About;